var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4451 51.4804V31.7813C18.5457 31.7813 17.6832 32.1363 17.0472 32.7682C16.4112 33.4001 16.0537 34.2572 16.0535 35.151V52.1196C17.1652 51.8851 18.2957 51.672 19.4451 51.4804Z",
    fill: "#8a1e86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8259 50.5573V22.685C25.743 22.7594 24.7289 23.2395 23.9885 24.0282C23.248 24.817 22.8363 25.8556 22.8366 26.9343V50.984C24.1497 50.814 25.4794 50.6718 26.8259 50.5573Z",
    fill: "#8a1e86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 50.2146C35.5686 50.2146 36.1345 50.2236 36.6994 50.2336V13C35.2973 13 33.9527 13.5535 32.9613 14.5388C31.9698 15.5241 31.4128 16.8604 31.4128 18.2539V50.2851C32.6028 50.2417 33.7973 50.2146 35 50.2146Z",
    fill: "#8a1e86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2746 50.8701V22.6741C45.1372 22.6744 44.0466 23.1235 43.2424 23.9227C42.4381 24.7219 41.9862 25.8059 41.986 26.9362V50.4705C43.4337 50.5705 44.8632 50.7037 46.2746 50.8701Z",
    fill: "#8a1e86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9547 52.1223V31.7795C53.5092 31.7795 53.0681 31.8667 52.6566 32.0362C52.245 32.2056 51.8711 32.454 51.5562 32.7671C51.2412 33.0802 50.9914 33.4518 50.821 33.8609C50.6507 34.2699 50.563 34.7083 50.5631 35.151V51.4822C51.7112 51.6751 52.8418 51.8884 53.9547 52.1223Z",
    fill: "#8a1e86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52.5943C23.3825 52.5943 12.8321 54.6511 5 58H65C57.1679 54.6511 46.6175 52.5943 35 52.5943Z",
    fill: "#8a1e86"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c44fe279103f9f0d16c152f2b8c2b6d5.svg";
export { ForwardRef as ReactComponent };